import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { ApiConfigurationEntity } from './api-configuration.entity';
import { BaseEntity } from './base.entity';
import { ParameterEntity } from './parameter.entity';

@Index('_fk__api_configuration__id', ['fkApiConfigurationId'], {})
@Index('_fk__parameter__id', ['fkParameterId'], {})
@Entity('_api_configuration__parameter')
export class ApiConfigurationParameterEntity extends BaseEntity {
	@Column('int', { name: '_fk__parameter__id', unsigned: true })
	public fkParameterId!: number;

	@Column('int', { name: '_fk__api_configuration__id', unsigned: true })
	public fkApiConfigurationId!: number;

	@ManyToOne(
		() => ParameterEntity,
		(parameter) => parameter.apiConfigurationParameters,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: '_fk__parameter__id', referencedColumnName: 'id' }])
	public fkParameter!: ParameterEntity;

	@ManyToOne(
		() => ApiConfigurationEntity,
		(apiConfiguration) => apiConfiguration.apiConfigurationParameters,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__api_configuration__id', referencedColumnName: 'id' },
	])
	public fkApiConfiguration!: ApiConfigurationEntity;
}
